import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root',
})
export class AppInsightsService {
  appInsights: ApplicationInsights;

  static createConfig(): {
    connectionString: string;
    enableAutoRouteTracking: boolean;
    disableCookiesUsage: boolean;
  } {
    return {
      connectionString: environment.appInsightsConnectionString,
      enableAutoRouteTracking: true,
      disableCookiesUsage: true,
    };
  }

  constructor() {
    // Initialize Application Insights instance
    this.appInsights = new ApplicationInsights({
      config: AppInsightsService.createConfig(),
    });
    this.appInsights.loadAppInsights();
  }

  logPageView(name?: string, uri?: string) {
    this.appInsights.trackPageView({ name, uri }); // Manually log a page view
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name }, properties); // Log custom events
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception, severityLevel });
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }): void {
    this.appInsights.trackMetric({ name, average }, properties);
  }
}
